import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentState } from './payment.state';

export const selectPayment = createFeatureSelector<PaymentState>('payment');
